import * as axios from 'axios';

const client_id = '20200912';
const client_secret = 'nc84bs7743p0uwhd';

let API_URL = '';
if (process.env.NODE_ENV==='production') {
    API_URL = 'https://coach.kolizey.fit/'
} else {
    API_URL = 'https://kln.g-service.ru/'
}

const instance = axios.create({
  
    withCredentials: true,
    crossDomain: true,
    baseURL: API_URL,
   
    headers: { 'content-type': 'application/json'  },
  
});

export const authAPI = {
    getMe() {
        return instance.get("auth",{withCredentials: true})
            .then(
                response => { return response.data }
            )
    },
    
    login(username, password) {
        return instance.post("auth",{client_id,client_secret,username, password},{withCredentials: true})
            .then(
                response => { return response.data }
            )
    },

    logout() {
        return instance.delete("auth")
            .then(
                response => { return response.data }
            )       
    },

    changePassword(token,oldPass,newPass) {
        return instance.post("api/users/changepassword",{oldPass,newPass},{headers: {"token":token}})
            .then(
                response => { return response.data }
            )          
    },

    userList(token, page=0, rows=10) {
        return instance.get(`api/users/userlist?page=${page}&rows=${rows}`,{headers: {"token":token}})
            .then(
                response => { return response.data }
            )
    },

    userData(token, userId) {
        return instance.get(`api/users/userdata?userId=${userId}`,{headers: {"token":token}})
            .then(
                response => { return response.data }
            )
    },

    addUser(token, data) {
        return instance.post("api/users/adduser",data,{headers: {"token":token}})
            .then(
                response => { return response.data }
            )    
    },

    changeUser(token, data) {
        return instance.post("api/users/changeuser",data,{headers: {"token":token}})
            .then(
                response => { return response.data }
            )    
    }
}